// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.

import Vue from 'vue'
import Modernizr from 'modernizr'
import isRetina from 'is-retina'
import VueLocalStorage from 'vue-localstorage'

import App from './App'
import router from './router'

import NC from '@/lib/notification-center'
import store from '@/lib/store'
import base64 from '@/lib/base64'

import data from '@/assets/data.json'

Vue.config.productionTip = false;

Vue.mixin({
  data: function () {
    return {
      store: store,
      db: data
    }
  }
});

Vue.use(VueLocalStorage);

/* eslint-disable no-new */
window.app = new Vue({
  el: '#app',
  router,
  template: '<App/>',
  components: { App },

  data: {
    key: false
  },

  watch: {
    key(key) {
      try {
        if(base64.decode(key) == 'admin') router.push({name: 'admin'});
      }
      catch(e) {
        console.error('wrong key');
      }
    }
  },

  mounted() {
    window.scrollTop = 0;

    this._onResize();
    window.addEventListener('resize', this._onResize);
    window.addEventListener('scroll', this._onScroll);

    this._onChangeShowModal();
    this.$watch('store.showModal', this._onChangeShowModal);

    this.store.isRetina = isRetina();
  },

  methods: {

    _onScroll() {
      NC.emit('scroll');
    },

    _onResize() {
      NC.emit('resize', window.innerWidth, window.innerHeight)

      this.store.isLarge = (window.innerWidth > 768)
      this.store.scrollFx = this.store.isLarge;
      this.store.virtualScroll = (navigator.userAgent.indexOf('Chrome') > -1);
    },

    _onChangeShowModal() {
      const action = (this.store.showModal) ? 'add' : 'remove';
      document.body.classList[action]('no-scroll');
    }

  }
})



// WEBPACK FOOTER //
// ./src/main.js